export const JWT_TOKEN = 'jwt_token'
export const DEVICE_ID = 'device_id'
export const USER_ID = 'user_id'
export const CURRENT_LANGUAGE = 'current-language'
